export default __webpack_public_path__ + "static/media/wuyeTwo.2e6de733.png";